<menu style="padding-left: 0px;" *ngIf="mostrarMenu == 1"></menu>
<div class="contenido" [ngClass]=" {'contenidoSinOffset': mostrarMenu == 0} ">
<router-outlet></router-outlet>
</div>
<footer *ngIf="mostrarMenu == 1"></footer>
<div class="helpButton noPrint" *ngIf="mostrarChat===0  && token != null" (click)="mostrarChat=1" matTooltip="¿Tienes alguna pregunta?">
    <mat-icon class="gray-10">chat</mat-icon>
</div>
<chat-soporte *ngIf="mostrarChat===1 " class="chatContainer zIndex10 noPrint" (cerrarChatEvent)="cerrarChat($event)" ></chat-soporte>